<div
  class="player-container"
  [ngClass]="{
    'player-push-top': store.selectedParts,
    isVisible: playerIsVisible,
    'table-mode': isIPC3D && store.tableMode
  }">
  @if (!isIPC3D && !store.dmItemsDrawerOpen) {
    <button (click)="setView('default')" class="close-button" mat-icon-button title="close button" type="button">
      <mat-icon class="o-icon marked" svgIcon="close" />
    </button>
  }
  <o-notes-button class="notes-button"></o-notes-button>

  <div id="iframe" class="iframe"></div>
  @if (isIPC3D) {
    <div class="switch-view-button-container">
      <button
        (click)="changeCurentView('viewGeneral')"
        [disabled]="runSwitchView"
        [ngClass]="{ activate: store.currentViewIdSignal() === 'viewGeneral' }"
        title="general view button"
        type="button">
        <mat-icon class="marked" svgIcon="block" />
      </button>
      <button
        (click)="changeCurentView('viewExploded')"
        [disabled]="runSwitchView"
        [ngClass]="{ activate: store.currentViewIdSignal() === 'viewExploded' }"
        title="exploded view button"
        type="button">
        <mat-icon class="marked" svgIcon="block-exploded" />
      </button>
    </div>
  }
</div>
